<template>
  <div class="main">
    <div class="main_top">
      <div class="schoolBtn">
        <!-- <Button
          Icon
          icon="md-trash"
        >
          导入模板下载
        </Button>
        <Button
          Icon
          icon="md-trash"
        >
          导入
        </Button> -->
        <Model msg="新增" icon="md-add" @MajorTreeList="getschoolDataList"></Model>
        <Model msg="编辑" icon="ios-create" :majorChange="majorChange" @MajorTreeList="getschoolDataList"></Model>
        <Button Icon icon="md-trash" @click="deleteSchool" @MajorTreeList="getschoolDataList">
          删除
        </Button>
      </div>
    </div>
    <div class="main_body">
      <el-table :data="majorDataList" stripe highlight-current-row @current-change="handleCurrentChange" row-key="orgid" style="width: 100%" max-height="700">
        >
        <el-table-column type="index" width="80" label="序号" align="center"> </el-table-column>
        <el-table-column prop="orgname" label="专业名称" width="200" align="center"> </el-table-column>
        <el-table-column prop="orgcode" label="专业编号" align="center"> </el-table-column>
        <el-table-column prop="orgshortname" label="专业简称" align="center"> </el-table-column>
        <el-table-column prop="manager" label="专业负责人" align="center"> </el-table-column>
        <el-table-column prop="description" label="备注" align="center"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'
import Model from '../../components/system/majorBtn'

export default {
  data() {
    return {
      majorChange: {},
      majorDataList: []
    }
  },
  components: {
    Model: Model
  },

  watch: {},
  mounted() {},
  methods: {
    //获取专业列表
    async GetspecialtynList() {
      const res = await Api.organization.GetspecialtynList()
      if (res.success != true) return this.Message(res.msg)
      this.majorDataList = res.rows
    },
    getschoolDataList(data) {
      this.majorDataList = data
    },
    //表格选中项
    handleCurrentChange(val) {
      this.majorChange = val
    },
    //删除
    deleteSchool() {
      if (JSON.stringify(this.majorChange) == '{}') {
        return this.$Message.info('请选择删除项!')
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const res = await Api.organization.DelOrganization([this.majorChange.orgid])
          if (res.success) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
          this.GetspecialtynList()
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .main_top {
    height: 60px;
    padding: 10px 15px 0 0;
    .schoolBtn {
      float: right;
      /deep/.ivu-btn {
        padding: 0 10px;
      }
      display: flex;
      > div {
        margin-right: 5px;
      }
      > button {
        margin-right: 5px;
      }
    }
  }
}
</style>
